import Vue from "vue";
import Vuex from "vuex";
import pathify from "./pathify";
import { commit, make } from "vuex-pathify";
import localStoragePlugin from "./plugins/localStorage";

import { DiceRoller } from "rpg-dice-roller";

const roller = new DiceRoller;

const state = {
  lastRoll: "",
  rollFieldValue: "",
  log: [],
  selectedFavoritesGroupIndex: 0,
  formulaModalShown: false,
  favoritesModalShown: false,
  settingsModalShown: false,
  createFavoriteModalShown: false,
  editFavoriteModalShown: false,
  createGroupModalShown: false,
  editGroupModalShown: false,
  favorites: [
    {
      name: "Group 1",
      rolls: [
        {
          creationMs: 123123,
          name: "Roll 1",
          notation: "d20+5",
          color: "blue"
        },
        {
          creationMs: 123124,
          name: "Roll 2",
          notation: "d12+3",
          color: "red"
        }
      ]
    },
    {
      name: "Ritlock",
      rolls: [
        {
          creationMs: 123125,
          name: "Attack",
          notation: "d20+7",
          color: "red"
        },
        {
          creationMs: 123126,
          name: "Bite damage",
          notation: "d6+3",
          color: "teal"
        },
        {
          creationMs: 123127,
          name: "Claws damage",
          notation: "d10+3",
          color: "teal"
        }
      ]
    }
  ],
  wakeLock: false,
  darkMode: true,
  highlightMinAndMaxRolls: true,
  showFavoritesGroupNameInLog: true
};

const getters = make.getters(state);

const mutations = {
  ...make.mutations(state),
  initializeStore() {
    const data = localStorage.getItem("appState");
    if (data) {
      this.replaceState(Object.assign(this.state, JSON.parse(data)))
    }
  },
  addRollToLog(state, rollResult) {
    state.log.unshift(rollResult);
  }
};

const actions = {
  ...make.actions(state),
  clearLog({ commit }) {
    commit("lastRoll", "");
    commit("log", []);
  },
  roll({ commit }, { notation, name }) {
    const rollResult = {
      rollData: roller.roll(notation),
      name,
      timestamp: Date.now()
    };
    commit("lastRoll", rollResult);
    commit("addRollToLog", rollResult);
  },
  addFavorite({ state }, { groupIndex, newFavorite }) {
    state.favorites[groupIndex].rolls.push({
      creationMs: Date.now(),
      ...newFavorite
    });
  },
  updateFavorite({ state }, { favoriteIndex, groupIndex, data }) {
    Vue.set(state.favorites[groupIndex].rolls, favoriteIndex, data);
  },
  deleteFavorite({ state }, { favoriteIndex, groupIndex }) {
    Vue.delete(state.favorites[groupIndex].rolls, favoriteIndex);
  },
  addGroup({ state }, newGroup) {
    state.favorites.push({
      name: newGroup.name,
      rolls: []
    });
  },
  updateGroup({ state }, { groupIndex, data }) {
    Vue.set(state.favorites, groupIndex, { ...state.favorites[groupIndex], ...data });
  },
  deleteGroup({ state }, { groupIndex }) {
    if (state.favorites.length > 1) {
      if (state.selectedFavoritesGroupIndex > 0) {
        state.selectedFavoritesGroupIndex--;
        Vue.delete(state.favorites, groupIndex);
      } else {
        Vue.delete(state.favorites, groupIndex);
      }
    } else {
      console.log("cannot delete last group")
    }
  },
  showFormulaModal() {
    commit("formulaModalShown", true);
  },
  hideFormulaModal() {
    commit("formulaModalShown", false);
  },
  toggleFormulaModal({ state }) {
    commit("formulaModalShown", !state.formulaModalShown);
  },
  showFavoritesModal() {
    commit("favoritesModalShown", true);
  },
  hideFavoritesModal() {
    commit("favoritesModalShown", false);
  },
  toggleFavoritesModal({ state }) {
    commit("favoritesModalShown", !state.favoritesModalShown);
  },
  showSettingsModal() {
    commit("settingsModalShown", true);
  },
  hideSettingsModal() {
    commit("settingsModalShown", false);
  },
  toggleSettingsModal({ state }) {
    commit("settingsModalShown", !state.settingsModalShown);
  },
  toggleSetting({ state, commit }, settingName) {
    const settingStatus = state[settingName];
    if (settingStatus) {
      commit(settingName, false);
    } else {
      commit(settingName, true);
    }
  },
  hideCreateFavoriteModal() {
    commit("createFavoriteModalShown", false);
  },
  showCreateFavoriteModal() {
    commit("createFavoriteModalShown", true);
  },
  hideEditFavoriteModal() {
    commit("editFavoriteModalShown", false);
  },
  showEditFavoriteModal() {
    commit("editFavoriteModalShown", true);
  },
  hideCreateGroupModal() {
    commit("createGroupModalShown", false);
  },
  showCreateGroupModal() {
    commit("createGroupModalShown", true);
  },
  hideEditGroupModal() {
    commit("editGroupModalShown", false);
  },
  showEditGroupModal() {
    commit("editGroupModalShown", true);
  },
};

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [
    pathify.plugin,
    localStoragePlugin
  ],
  getters,
  state,
  mutations,
  actions
});
